export default {
  推荐66人: `แนะนำเพื่อน 66 คน รับสิทธิ์บินตรงสู่บาร์เซโลนา`,
  成为EBC推荐官: "เข้าร่วมโปรแกรมผู้แนะนำ EBC รับประสบการณ์ระดับ VIP",
  立即参与: "ลงทะเบียนตอนนี้",
  活动规则与要求: "กติกาและเงื่อนไขกิจกรรม",
  每一次推荐: "ทุกการแนะนำ คือโอกาสสู่บาร์เซโลนา",
  参与规则: "เงื่อนไขกิจกรรม:",
  成为EBC推荐官并邀请66人: "เข้าร่วมโปรแกรมผู้แนะนำ EBC ชวนเพื่อนครบ 66 คน",
  所有被邀请人均入金大于等于$500: `โดยแต่ละคนที่คุณแนะนำต้องฝากเงินอย่างน้อย $500 และทำการเทรด 1 ครั้ง`,
  参与方法: "ขั้นตอนเข้าร่วมกิจกรรม:",
  立即推荐: "เริ่มแนะนำตอนนี้ แล้วฉลองแชมป์ไปด้วยกัน",
  登录EBC用户中心: "เข้าสู่ระบบที่ศูนย์ผู้ใช้งาน EBC",
  "进入“大赛推荐官”活动页面": "ไปที่กิจกรรม “โปรแกรมผู้แนะนำ”",
  生成您的邀请链接或二维码: "สร้างลิงก์แนะนำ หรือแชร์  QR โค้ดให้เพื่อนคุณ",
  巴萨荣耀之旅: "เส้นทางแชมป์สู่ FC Barcelona",
  每笔订单都是攻守博弈的艺术: `เกมรุกที่เฉียบคม แนวรับที่แข็งแกร่ง คือ กุญแจสู่ชัยชนะ`,
  活动时间: "ระยะเวลากิจกรรม:",
  "2025年2月22日": "22 ก.พ. 2025 เวลา 01:00 น.(เวลา MT4/MT5) - ส.ค. 2025 (เวลา MT4/MT5)",
  活动规则: "เงื่อนไขกิจกรรม",
  ruleList: [
    "กิจกรรมเชิญเพื่อน 66 คน ไม่ขัดแย้งกับรางวัลจากโปรแกรมผู้แนะนำและกิจกรรมอื่น ๆ",
    "ผู้ถูกเชิญต้องทำการฝากเงินและเทรดตามเงื่อนไข และการโอนเงินผ่านบุคคลที่สามจะถือว่าผิดเงื่อนไข",
    "ผู้เข้าร่วมกิจกรรมที่ปฏิบัติตามเงื่อนไขเท่านั้นถึงมีสิทธิ์รับเงินรางวัล EBC สามารถยกเลิกสิทธิ์มอบรางวัล สำหรับผู้ที่ฝ่าฝืนเงื่อนไข",
    "บัญชีที่ลงทะเบียนผ่านลิงก์แนะนำไม่ได้รับอนุญาตให้โอนตัวแทน",
    "รางวัลขึ้นอยู่กับการเปิดใช้งานบัญชีอย่างถูกต้อง และตั๋วชมการแข่งขันแบบ VIP รวมค่าเครื่องบินและที่พักเรียบร้อยแล้ว",
    "EBC Financial Group มีสิทธิ์ในการตีความและตัดสิน ทุกกรณีที่เกี่ยวข้องกับกิจกรรมนี้",
  ],
};
